import Model, { attr } from '@ember-data/model';

export default class AddressSuggestionModel extends Model {
  @attr('string') text;
}
